import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { managementCompetencyKeys } from "@/lib/query";

export interface ManagementCompetencyRow {
  id: string;
  competencyId: string;
  competencyName: string;
}

export function useManagementCompetencies() {
  return useQuery({
    queryKey: managementCompetencyKeys.all,
    queryFn: async (): Promise<ManagementCompetencyRow[]> => {
      const res = await fetch("/api/management-competencies");
      if (!res.ok) throw new Error("Failed to fetch the management capability set");
      const json = await res.json();
      return json.data;
    },
  });
}

export function useSetManagementCompetencies() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (items: { competencyId: string }[]) => {
      const res = await fetch("/api/management-competencies", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.error ?? "Update failed");
      }
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: managementCompetencyKeys.all });
      toast.success("Management capability set updated");
    },
    onError: (e: Error) => toast.error(e.message ?? "Failed to update the management set"),
  });
}
